import React from 'react';
import { AdminToolCard } from './AdminToolCard';
import './AdminNavigationGrid.css';

export function AdminNavigationGrid({ manager }) {
  // Get admin tools from the manager
  const adminTools = manager ? manager.getAdminTools() : [
    {
      id: 'home',
      title: 'Home',
      description: 'Overview and dashboard',
      icon: 'fa-home',
      path: '/admin'
    }
  ];

  return (
    <div className="admin-navigation-grid">
      <div className="admin-grid-container">
        {adminTools.map((tool) => (
          <AdminToolCard key={tool.id} tool={tool} />
        ))}
      </div>
    </div>
  );
}